import React from 'react';
import PropTypes from 'prop-types';
import {
  Table,
} from 'reactstrap';

import AdminPanelClientListHeader from './ClientListHeader';
import AdminPanelClientListItem from './ClientListItem';

import Loading from '../Loading';

const AdminPanelClientList = ({
  clients,
  loading,
  orderBy,
  order,
  handleChangeOrder,
  afterClientDeleted,
  afterClientUpdated,
}) => (
  <div className="table-wrapper">
    <Table className="users-list" responsive>
      <thead>
        <AdminPanelClientListHeader
          orderBy={orderBy}
          order={order}
          handleChangeOrder={handleChangeOrder}
        />
      </thead>
      {loading ? (
        <tbody>
          <tr>
            <td colSpan={7}>
              <Loading />
            </td>
          </tr>
        </tbody>
      ) : (
        <tbody>
          {clients.map(client => (
            <AdminPanelClientListItem
              key={client.uuid}
              client={client}
              afterClientDeleted={afterClientDeleted}
              afterClientUpdated={afterClientUpdated}
            />
          ))}
        </tbody>
      )}
    </Table>
  </div>
);

AdminPanelClientList.propTypes = {
  clients: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  orderBy: PropTypes.string.isRequired,
  order: PropTypes.string.isRequired,
  handleChangeOrder: PropTypes.func.isRequired,
  afterClientDeleted: PropTypes.func.isRequired,
  afterClientUpdated: PropTypes.func.isRequired,
};

export default AdminPanelClientList;
